import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const removeCampaign = async (domain: string, campaignId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `campaigns/${campaignId}`,
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}